<!--
 * @Description: 角色配置页面
 * @Author: laoliu，wanqian
 * @Date: 2021-01-17 22:43:52
-->
<template>
  <role-cfg :marginHorizontal="40"></role-cfg>
</template>

<script>
export default {
	mounted() {
			this.$emit("breadcrumb", {text1: '系统配置', text2: '角色配置'});
	}
}
</script>


// WEBPACK FOOTER //
// src/components/syscfg/RoleCfg.vue